import { ReactIntegration, getWebInstrumentations, initializeFaro } from "@grafana/faro-react";
import { TracingInstrumentation } from "@grafana/faro-web-tracing";
import main from "../../../package.json";
import config from "@src/utilities/config";

const isMonitoringEnabled = process.env.NODE_ENV === "production";
const dev = config.debug;

if (isMonitoringEnabled && !dev) {
  initializeFaro({
    url: "https://faro-collector-prod-eu-west-2.grafana.net/collect/aace6bbec7b5418fb1742ffbbccee1dc",
    app: {
      name: "Web Booking System",
      version: main.version,
      environment: "production",
    },
    instrumentations: [...getWebInstrumentations(), new TracingInstrumentation(), new ReactIntegration()],
    ignoreErrors: [],
  });
}

export { isMonitoringEnabled };
export { FaroErrorBoundary } from "@grafana/faro-react";